import axios from 'axios';
import { router } from 'src';

import { api } from 'src/api';
import { config } from 'src/config/config';
import { AuthToken } from 'src/state/auth/types';

import { NavigationService, navigationService } from './navigation-service';

export class AuthenticationService {
  public static fetchToken = async (code: string, verifier: string): Promise<AuthToken> => {
    const { AUTH_TOKEN_URL, AUTH_CLIENT_ID } = config;
    const redirectUri = navigationService.getRedirectUri();

    return axios
      .post(
        AUTH_TOKEN_URL,
        {
          grant_type: 'authorization_code',
          code,
          redirect_uri: redirectUri,
          code_verifier: verifier,
        },
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          auth: {
            username: AUTH_CLIENT_ID,
            password: '',
          },
        },
      )
      .then((response) => response.data);
  };

  public static readonly logout = (): Promise<void> => {
    router.navigate(NavigationService.LOGOUT);

    return (
      api.authController
        .logout()
        // eslint-disable-next-line no-console
        .catch(() => console.warn('Failed to logout'))
        .finally(() => {
          navigationService.goToMainPage();
        })
    );
  };
}
